(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sukhafe-home"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Carrusel del hero
    document.querySelectorAll('.sk-home .sk-carousel').forEach(function(car){
      var imgs = car.querySelectorAll('img'); if(imgs.length < 2) return;
      var i = 0; if(!car.querySelector('img.on')) imgs[0].classList.add('on');
      setInterval(function(){ imgs[i].classList.remove('on'); i=(i+1)%imgs.length; imgs[i].classList.add('on'); }, 2800);
    });

    if(reduce) return;

    // Aparición con profundidad
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .14 });
    document.querySelectorAll('.sk-home .sk-reveal').forEach(function(el){ io.observe(el); });

    // Parallax del hero (sensación de sumergirse)
    var pels = [].slice.call(document.querySelectorAll('.sk-home [data-parallax]'));
    var ticking = false;
    function onScroll(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){
        var y = window.pageYOffset || document.documentElement.scrollTop;
        pels.forEach(function(el){
          var sp = parseFloat(el.getAttribute('data-parallax')) || 0;
          var t = y * sp;
          el.style.transform = 'translate3d(0,' + t.toFixed(1) + 'px,0)';
          if(el.getAttribute('data-fade') && y < 760){ el.style.opacity = Math.max(0, 1 - y/640); }
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sukhafe-renta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.currentScript ? document : document;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Aparición
    if(!reduce && 'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
      document.querySelectorAll('.rc-renta .rc-reveal').forEach(function(el){io.observe(el);});
    } else {
      document.querySelectorAll('.rc-renta .rc-reveal').forEach(function(el){el.classList.add('in');});
    }
    if(reduce) return;
    // Giro 3D al mover cursor/dedo
    document.querySelectorAll('.rc-renta .rc-media[data-tilt]').forEach(function(m){
      var img=m.querySelector('img'); if(!img) return;
      function move(e){
        var p=e.touches?e.touches[0]:e; var r=m.getBoundingClientRect();
        var x=(p.clientX-r.left)/r.width-0.5, y=(p.clientY-r.top)/r.height-0.5;
        img.style.transition='transform .06s linear';
        img.style.transform='rotateY('+(x*30).toFixed(1)+'deg) rotateX('+(-y*22).toFixed(1)+'deg) scale(1.07)';
      }
      function reset(){ img.style.transition='transform .55s ease'; img.style.transform=''; }
      m.addEventListener('pointermove',move);
      m.addEventListener('pointerleave',reset);
      m.addEventListener('touchmove',function(e){move(e);},{passive:true});
      m.addEventListener('touchend',reset);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
